import { AccountOnboardingResponseDTO } from '@/core/api/dtos/response/accounts/accountOnboarding'
import { AccountOnboarding } from '@/core/api/entities/account/accountOnboarding'

export class AccountOnboardingMapper {
	static toEntity(dto: AccountOnboardingResponseDTO): AccountOnboarding {
		return AccountOnboarding.create({
			userInformationReady: dto.user_information_ready,
			brandProfileReady: dto.brand_profile_ready,
			firstZoneReady: dto.first_zone_ready,
			musicAssignmentReady: dto.music_assignment_ready,
			downloadReady: dto.download_ready,
		})
	}
}
